/**
 * This File is generated. Do not edit.
 */
import '@mdi/font/css/materialdesignicons.min.css';
import Vuetify from 'vuetify';
import VCalendar from 'v-calendar';

import { ACTION_NAME } from '@ads/iam-library';
import LightTheme from './themes/light';
import './scss/main.scss';
import { createIamEnforcerDirective } from './directives/userPermissions';
import './vuetify-loader.conf.js';

const vuetify = new Vuetify({
    // Disables tree shaking
    css: false,
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: LightTheme,
        },
        icons: {
            iconfont: 'mdi',
        },
    },
});

const designSystem = {
    install(VueInstance) {
        VueInstance.use(VCalendar, {
            componentPrefix: 'custom',
        });
        VueInstance.use(Vuetify);
        VueInstance.directive('can', createIamEnforcerDirective());
        VueInstance.directive('can-read', createIamEnforcerDirective(ACTION_NAME.READ));
        VueInstance.directive('can-create', createIamEnforcerDirective(ACTION_NAME.CREATE));
        VueInstance.directive('can-edit', createIamEnforcerDirective(ACTION_NAME.EDIT));
        VueInstance.directive('can-remove', createIamEnforcerDirective(ACTION_NAME.REMOVE));
        VueInstance.directive('can-archive', createIamEnforcerDirective(ACTION_NAME.ARCHIVE));
        VueInstance.directive('can-publish', createIamEnforcerDirective(ACTION_NAME.PUBLISH));
    },
};

export default designSystem;
export { vuetify };

export * from './components/SrURLInput';
export * from './components/SrTooltip';
export * from './components/SrTabs';
export * from './components/SrTable';
export * from './components/SrSwitch';
export * from './components/SrSlider';
export * from './components/SrSelect';
export * from './components/SrSearchInput';
export * from './components/SrRadioButton';
export * from './components/SrNotification';
export * from './components/SrNavigationBar';
export * from './components/SrModal';
export * from './components/SrMenu';
export * from './components/SrMarketingCloudLogo';
export * from './components/SrListItemTitle';
export * from './components/SrListItemSubtitle';
export * from './components/SrListItemIcon';
export * from './components/SrListItemGroup';
export * from './components/SrListItemContent';
export * from './components/SrListItemAvatar';
export * from './components/SrListItemActionText';
export * from './components/SrListItemAction';
export * from './components/SrListItem';
export * from './components/SrListGroup';
export * from './components/SrList';
export * from './components/SrLinkList';
export * from './components/SrLabel';
export * from './components/SrInputLabel';
export * from './components/SrInputBox';
export * from './components/SrInput';
export * from './components/SrInfoBox';
export * from './components/SrIcon';
export * from './components/SrHeadline';
export * from './components/SrFilter';
export * from './components/SrEngagementTooltip';
export * from './components/SrEditableList';
export * from './components/SrDropzoneUploadFileList';
export * from './components/SrDropzoneUpload';
export * from './components/SrDateTimePicker';
export * from './components/SrDateTimeInput';
export * from './components/SrDateRangePicker';
export * from './components/SrDatePicker';
export * from './components/SrDataPlaceholder';
export * from './components/SrColorPicker';
export * from './components/SrCheckbox';
export * from './components/SrButtonGroup';
export * from './components/SrButton';
export * from './components/SrBrandLogo';
export * from './components/SrBodyText';
export * from './components/SrAdvancedFilter';
export * from './layout/SrModalPageForm';
export * from './layout/SrModalPage';
export * from './layout/SrHeader';
export * from './layout/SrFooter';
export * from './layout/SrAppContainer';
export * from './filters';
export * from './directives/userPermissions';
export * from './utils/classNames';
